import type { GetImpactByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetImpactByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactByIdArgs = {
  id: string;
};

export const useGetImpactById = createQueryHook<
  UseGetImpactByIdArgs,
  GetImpactByIdResponseRow[],
  GetImpactByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.impact.impactById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ impact: data }),
  graphqlDocument: GetImpactByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
